/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from './../lib/lib'

export default class Newsletter {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.form = jQuery('#newsletter-form')
    this.loader = jQuery('.e-loader', this.$element)
    this.main = jQuery('.s-newsletter__main', this.$element)
    this.thankyou = jQuery('.s-newsletter__thankyou', this.$element)
    this.emailInput = jQuery('#newsletter-form-email', this.$element)
    this.timeout = 100

    const { configuration = {} } = lib.getData('newsletterData') || {}

    const { contactPigeon } = configuration
    if (!contactPigeon) {
      return false
    }

    this.form.on('submit', (e) => {
      e.preventDefault()

      this.loader.show()

      setTimeout(() => {
        /* eslint-disable camelcase */
        const postData = {
          gm_pid: contactPigeon.gm_pid,
          is_silentcall: 'yes',
          sfemail: this.emailInput.val(),
          sfcrcheckbox: 1,
        }
        jQuery.ajax({
          type: 'POST',
          async: false,
          url: contactPigeon.endpoint,
          data: postData,
          success: (response) => {
            const { retmsg } = JSON.parse(response)

            if (retmsg === 'CONFIRMATION_EMAIL_SENT_MUST_VERIFY') {
              this.loader.hide()
              this.main.toggle()
              this.thankyou.toggle()
            } else {
              this.loader.hide()
              alert('An error occured')
            }
          },
          error: (jqXHR, textStatus, errorThrown) => {
            this.loader.hide()
            alert('An error occured')
            console.error(errorThrown)
          },
        })
      }, this.timeout)
    })
  }
}
